export default {
  RECAPTCHA_REPOSITORY: Symbol.for('RECAPTCHA_REPOSITORY'),
  GET_RECAPTCHA_QUERY: Symbol.for('GET_RECAPTCHA_QUERY'),
  LOAD_SCRIPT_CAPTCHA: Symbol.for('LOAD_SCRIPT_CAPTCHA'),
};
